import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-1f5c3483"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password-reset-page overflow-x-hide" }
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = { class: "row no-margin" }
const _hoisted_4 = { class: "col-md-12 flex-container" }
const _hoisted_5 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "modal-body-sec1" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  for: "id",
  class: "control-label input-label-form"
}
const _hoisted_13 = { class: "help-text" }
const _hoisted_14 = { class: "letsgo-btn" }
const _hoisted_15 = ["disabled"]

import HeaderLogo from "@/components/common/headerLogo.vue";
import BrandPattern2 from "@/components/prospect/brandPattern/brandPattern2.vue";
import ErrorHandler from "@/components/common/exceptionHandler.vue";
import utilities from "@/utils/utilities";
import { successStatusCodes } from "@/utils/constants";
import { onBeforeUnmount, onMounted, ref } from "vue";
import Utils, { getComponentUiText } from "@/utils/utilities";
import { load } from "recaptcha-v3";
import { useRouter, useRoute } from "vue-router";
import store from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'verifyorganisation',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const token: any = ref("");
if (route.query && route.query.token) {
  token.value = route.query.token;
  router.push({ path: "/org/verify/email/callback" });
} else {
  router.push({ path: "/user/login" });
}

const dyn_height = ref("0");
const windowHeight = ref("");
const showProspectCallbackError = ref(false);
const prospectCallbackErrorMsg = ref("");
const email = ref("");
// const secretKey = ref(null);
const isPositiveNotification = ref(false);
const isLoading = ref(false);
const passwordResetModal = ref<null>(null);
const defaultUiText = ref(store.state.LanguagePicker.defaultUiText);
const languageSelectedText = ref(
  store.state.LanguagePicker.languageSelectedText,
);

const onResize = () => {
  dyn_height.value = `${window.innerHeight}px`;
  windowHeight.value = `${window.innerHeight}px !important`;
  // secretKey.value && secretKey.value.focus();
};

const getUiText = (id, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const resetShowProspectCallbackError = () => {
  showProspectCallbackError.value = false;
  prospectCallbackErrorMsg.value = "";
};

const submit = async () => {
  isLoading.value = true;
  const recaptcha = await getRecaptcha();
  const data = {
    recaptcha: recaptcha,
    token: token.value,
  };
  verifyOrganisation(data);
};
const verifyOrganisation = async (data) => {
  try {
    const res: any = await store.dispatch("Org/handleOrgVerifiCallback", data);
    if (res.status == successStatusCodes.OK) {
      showErrorInfo(
        {
          message: getComponentUiText("app-user-verify-successful-org-1"),
        },
        true,
      );
      setTimeout(() => {
        router.push({ path: "/settings/organisation/access" });
      }, 1000);
    } else {
      return showErrorInfo({
        message:
          res?.data?.error?.message ||
          getComponentUiText("app-user-verify-error-org-1"),
      });
    }
  } catch (error: any) {
    return showErrorInfo({
      message: getComponentUiText("app-user-verify-error-org-1"),
    });
  } finally {
    setTimeout(() => {
      isLoading.value = false;
    }, 1000);
  }
};
const showErrorInfo = (errorInfo, stateIsPositiveNotification = false) => {
  if (errorInfo && errorInfo !== "") {
    isPositiveNotification.value = stateIsPositiveNotification;
    errorInfo =
      typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;

    if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
      showProspectCallbackError.value = true;
      prospectCallbackErrorMsg.value = errorInfo.message;
    }
  }
};

const getRecaptcha = async () => {
  try {
    const finalKey = await Utils.getV3Recaptcha();
    const recaptcha = await load(`${finalKey}`, {
      autoHideBadge: true,
    });
    const token = await recaptcha.execute("submit");
    return token;
  } catch (error: any) {
    showErrorInfo(error.data);
    router.push({ path: "/" });
  }
};
const onClickClose = () => {
  router.go(-1);
};

const beforeUnmount = () => {
  if (document.body.classList.contains("page-opacity")) {
    document.body.classList.remove("page-opacity", "page-bg", "page-shadow");
  }
};

onMounted(() => {
  onResize();
  window.addEventListener("resize", onResize);
  document.getElementById("passwordResetModal")?.classList.add("show");
  if (!document.body.classList.contains("page-opacity")) {
    onResize();
    document.body.classList.add("page-opacity", "page-bg");
  }
});

onBeforeUnmount(() => {
  beforeUnmount();
  window.removeEventListener("resize", onResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "col-md-12",
          style: _normalizeStyle({ 'min-height': dyn_height.value })
        }, [
          _createVNode(HeaderLogo, {
            "page-type": `404`,
            "language-picker": true,
            light_logo: true
          }),
          _createElementVNode("div", {
            class: "row no-padding main-body h-100",
            style: _normalizeStyle({ height: windowHeight.value })
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(BrandPattern2, { page: "LOGIN" })
            ])
          ], 4)
        ], 4),
        (showProspectCallbackError.value || null)
          ? (_openBlock(), _createBlock(ErrorHandler, {
              key: 0,
              "prospect-callback-error-msg": prospectCallbackErrorMsg.value,
              "is-positive": isPositiveNotification.value,
              onResetShowProspectCallbackError: resetShowProspectCallbackError
            }, null, 8, ["prospect-callback-error-msg", "is-positive"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          id: "passwordResetModal",
          ref_key: "passwordResetModal",
          ref: passwordResetModal,
          class: "modal fade password-reset-modal tw-block",
          "aria-labelledby": "passwordResetModalLabel"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", { class: "modal-header" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  "aria-label": "Close",
                  onClick: onClickClose
                }, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(getUiText("app-user-verify-secret-org-title-1")), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(getUiText("app-user-verify-secret-org-content-1")), 1)
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(getUiText("app-user-verify-secret-org-note-1")), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary letsgo-button",
                    tabindex: "3",
                    disabled: isLoading.value,
                    onClick: submit
                  }, _toDisplayString(getUiText(
                        "app-settings-domain-verify-modal-verify-button-1",
                      )), 9, _hoisted_15)
                ])
              ])
            ])
          ])
        ], 512)
      ])
    ])
  ]))
}
}

})